import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { AuthProvider } from './contexts/AuthProvider';
import { ThemeProvider } from './contexts/ThemeProvider';
import { useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Auth from './pages/Auth';
import HealthCheck from './components/HealthCheck';
import ErrorBoundary from './components/ErrorBoundary';
import CheckoutPage from './pages/Checkout';
import ExpiredLink from './pages/ExpiredLink';
import './App.css';
import './theme.css';

function AppContent() {
  const { isAuthenticated } = useAuth();
  // Partner auth uses cookie + localStorage flag; allow it through the gate.
  const partnerAuthed =
    typeof window !== 'undefined' &&
    localStorage.getItem('partner_authenticated') === 'true';
  const allowed = isAuthenticated || partnerAuthed;

  return (
    <Router>
      <div className="min-h-screen bg-base-200 text-base-content">
        <Routes>
          {/* Always-on routes — render regardless of auth state so
              /login stays reachable even with stale auth flags. */}
          <Route path="/health" element={<HealthCheck />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/expired-link" element={<ExpiredLink />} />
          <Route path="/login" element={<Login />} />

          {allowed ? (
            <>
              <Route
                path="/"
                element={
                  <ErrorBoundary>
                    <Dashboard />
                  </ErrorBoundary>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ErrorBoundary>
                    <Dashboard />
                  </ErrorBoundary>
                }
              />
              <Route
                path="/checkout"
                element={
                  <ErrorBoundary>
                    <CheckoutPage />
                  </ErrorBoundary>
                }
              />
              {/* Unknown authed path → dashboard rather than a no-match warning */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </>
          ) : (
            <Route path="*" element={<Login />} />
          )}
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <AppContent />
        </ErrorBoundary>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
